import { createReducer, on, createFeature } from '@ngrx/store';
import { TankerLineUpReport } from '../models/tanker-line-up.model';
import * as TankersLineUpActions from './tankers-line-up.actions';

export interface TankersLineUpState {
  loading: boolean;
  report: TankerLineUpReport | null;
  error: any | null;
}

export const initialState: TankersLineUpState = {
  loading: false,
  report: null,
  error: null,
};

export const tankersLineUpFeature = createFeature({
  name: 'tankersLineUp',
  reducer: createReducer(
    initialState,
    on(TankersLineUpActions.loadTankerLineupReport, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(TankersLineUpActions.loadTankerLineupReportSuccess, (state, { report }) => ({
      ...state,
      loading: false,
      report,
      error: null,
    })),
    on(TankersLineUpActions.loadTankerLineupReportFailure, (state, { error }) => ({
      ...state,
      loading: false,
      report: null,
      error,
    }))
  ),
});
